import { Pagination, Popconfirm, Table, Tag, Tooltip } from "antd";
import moment from "moment";
import { CiEdit } from "react-icons/ci";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";

// Modified RoomDataTable component with sorting
function RoomDataTable(props: any) {
  const Events = useSelector((state: any) => state.Events);
  const user = useSelector((state: any) => state.User.user);
  
  const columns :any= [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: "Status",
      dataIndex: "has_allocated",
      key: "has_allocated",
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (value: boolean) => (
        value ? (
          <Tag color="green" style={{ width: 100, textAlign: "center", cursor: "default" }}>
            Occupied
          </Tag>
        ) : (
          <Tag color="blue" style={{ width: 100, textAlign: "center", cursor: "default" }}>
            Available
          </Tag>
        )
      )
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (item: any) => (
        <div style={{ fontSize: 12 }}>
          {moment(item).format("MMM D, YYYY h:mm:ss A")}
        </div>
      ),
    },
    {
      title: "Updated On",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (item: any) => (
        <div style={{ fontSize: 12 }}>
          {moment(item).format("MMM D, YYYY h:mm:ss A")}
        </div>
      ),
    },
    {
      title: "Actions",
      width: 120,
      render: (item: any) => (
        <div className="table-item">
          {Array.isArray(user.access[Events?.defult?.id]) &&
          user.access[Events?.defult?.id].includes(8) ? null : 
          <>
            <div onClick={() => props.onChange(item)}>
              <Tooltip placement="top" title={<div style={{ fontSize: 10 }}>Edit Room</div>}>
                <CiEdit size={25} />
              </Tooltip>
            </div>
            <Popconfirm
              placement="bottomLeft"
              title="Delete"
              description="Are you sure to delete this?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => props?.delete(item?.id)}
            >
              <div>
                <Tooltip placement="top" title={<div style={{ fontSize: 10 }}>Delete Room</div>}>
                  <IoIosCloseCircleOutline size={25} color="red" />
                </Tooltip>
              </div>
            </Popconfirm>
          </>}
        </div>
      ),
    },
  ];

// In RoomDataTable component
const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  let sortField = sorter.field;
  let sortOrder = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : '';
  
  // Call parent component's sorting handler
  props.onSortChange(sortField, sortOrder);
};
  return (
    <>
      <Table
        size="small"
        tableLayout="fixed"
        scroll={{ x: 1000 }}
        dataSource={props?.data}
        columns={columns}
        pagination={false}
        loading={props?.loading}
        onChange={handleTableChange}
        showSorterTooltip={false}
      />
      <br />
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Pagination
          total={props?.meta?.total_count}
          showSizeChanger
          showTotal={(total: any) => `Total ${props?.meta?.total_count} Rooms`}
          onChange={(page, pageSize) => props.onPageChange(page, pageSize)}
          defaultCurrent={props?.meta?.page}
          defaultPageSize={props?.meta?.take}
        />
      </div>
    </>
  );
}

export default RoomDataTable;
